import { useMemo } from 'react';

import {
  getInfinityTools,
  isDataDrivenGenerationTool,
  isMixtureTool,
} from 'src/data/generationTool';

/**
 * Returns a memoized array of generation tools sorted by groups and tools order
 * @param {object|null} options - Options object
 * @param {boolean} options.onlyDataDriven - If true, returns only data-driven tools
 * @returns {GENERATION_TOOL[]} - Array of generation tools
 */
export const useInfinityGenerationTools = (options = null) => {
  const onlyDataDriven = options?.onlyDataDriven;

  return useMemo(() => {
    const infinityTools = getInfinityTools();
    return infinityTools.filter(
      (tool) => !(onlyDataDriven && (!isDataDrivenGenerationTool(tool) || isMixtureTool(tool)))
    );
  }, [onlyDataDriven]);
};
